module.exports = __webpack_public_path__ + "img/header-bg.91d44ac1.png";